"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var TakeWhileInclusiveSubscriber = /** @class */ (function (_super) {
    __extends(TakeWhileInclusiveSubscriber, _super);
    function TakeWhileInclusiveSubscriber(destination, predicate) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.predicate = predicate;
        _this.index = 0;
        return _this;
    }
    TakeWhileInclusiveSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        destination.next(value);
        if (!result) {
            destination.complete();
        }
    };
    return TakeWhileInclusiveSubscriber;
}(rxjs_1.Subscriber));
var TakeWhileInclusiveOperator = /** @class */ (function () {
    function TakeWhileInclusiveOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileInclusiveOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeWhileInclusiveSubscriber(subscriber, this.predicate));
    };
    return TakeWhileInclusiveOperator;
}());
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes after the last emitted value
 * satisfies the `predicate`.
 *
 * `takeWhileInclusive` subscribes and begins mirroring the source Observable.
 * Each value emitted on the source is emitted then given to the `predicate`
 * function which returns a boolean, representing a condition to be satisfied by
 * the source values. The output Observable emits the source values until such
 * time as the `predicate` returns false, at which point `takeWhileInclusive`
 * stops mirroring the source Observable and completes the output Observable.
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable and completes after emitting a value that satisfies the condition
 * defined by the `predicate`.
 * @method takeWhileInclusive
 * @owner Observable
 */
function takeWhileInclusive(predicate) {
    return function (source) { return source.lift(new TakeWhileInclusiveOperator(predicate)); };
}
exports.takeWhileInclusive = takeWhileInclusive;
//# sourceMappingURL=index.js.map